module.exports = __webpack_public_path__ + "static/media/trust-banner-img.f4b8aa4b.png";